// import Swiper from '../../../node_modules/swiper/swiper-bundle.min';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export class Top{

  constructor(app) {

    var mvSwiper = new Swiper('#topSwiper', {
      loop: true,
      autoplay: true,
      speed: 1000,
      spaceBetween: 25,
      slidesPerView: 1,
      centerdSlide: true,
      breakpoints: {
        765: {
          slidesPerView: 3,
          spaceBetween: 60
        }
      },
      pagination: {
        el: '.swiper-pagination-mv',
        type: 'bullets',
      },
      navigation: {
        prevEl: '.top-mv-prev',
        nextEl: '.top-mv-next'
      },
      on: {
        init: function () {
          $('.top-mv').addClass('is-active');
        },
      }
    });
    
    var linkSwiper = new Swiper('#topLinkSwiper', {
      loop: true,
      autoplay: true,
      speed: 1000,
      spaceBetween: 22,
      slidesPerView: 1,
      centerdSlide: true,
      breakpoints: {
        765: {
          slidesPerView: 5,
          spaceBetween: 30
        }
      },
      pagination: {
        el: '.swiper-pagination-link',
        type: 'bullets',
      },
      navigation: {
        prevEl: '.top-link-prev',
        nextEl: '.top-link-next'
      }
    });
  }

}